import type { ChangeEvent } from 'react';
import styled from 'styled-components';

interface TextareaProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  maxLength?: number;
  rows?: number;
  className?: string;
}

const StyledTextarea = styled.textarea`
  ${({ theme: { colors, spacing, typography } }) => `
    width: 100%;
    min-height: ${spacing(30)};
    padding: ${spacing(3)} ${spacing(4)} ${spacing(8)};
    background-color: ${colors.veryGray};
    color: ${colors.white};
    border: 0.0625rem solid ${colors.blackSwan};
    border-radius: ${spacing(2)};
    font-family: ${typography.poppins};
    font-size: ${typography.xsmall};
    line-height: ${typography.lineHeight};
    resize: vertical;
    box-sizing: border-box;

    &::placeholder {
      color: ${colors.knop};
    }

    &:focus {
      outline: none;
      border-color: ${colors.focoltone};
    }
  `}
`;

export const Textarea = ({ value, onChange, placeholder, maxLength, rows = 3, className }: TextareaProps) => (
  <StyledTextarea
    className={className}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    maxLength={maxLength}
    rows={rows}
  />
);
